import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { AIActionHealthDto, AIActionHealthResponseDto } from '@/Domain/api/Action/dto/Action.dto';

export type ActionHealth = AIActionHealthDto & { window_days: number };

export const useActionHealth = (actionId: number | undefined, enabled: boolean) =>
  useQuery<AIActionHealthResponseDto, unknown, ActionHealth | null>({
    queryKey: [QueryKey.actions.basic.health],
    select: ({ window_days, actions }) => {
      if (!enabled) return null;
      const entry = actions.find((action) => action.ai_action_id === actionId);
      return entry ? { ...entry, window_days } : null;
    },
    enabled,
  });
